import { prodEnvironment } from "@/env/env"
import { ref } from "vue"
import { showConfirm } from "./map.services";
import { filteredListIntervenants, filteredListUsers, presentToast } from "./user.services";

export const isManager = ref(false);
export const estControleur = ref(false);

export const filtreTicket = ref('Attente validation');
export const filtreCategorie = ref('tous');

export const relatedTickets = ref();

export const intervention = ref('')
export const idImmeuble = ref('')
export const pboconcerne = ref('')
export const signalContinuite = ref('')
export const rapportcourt_r3 = ref('')
export const rapportcourt_maintenance = ref('')
export const rapportcourt_t7 = ref('')
export const rapportcourt_t7_maintenance = ref('')

export const pboconcerne_t7 = ref('')
export const intervention_t7 = ref('')
export const motifT7 = ref('')
export const intervenants = ref([])
export const ticketExistantId = ref('Aucun')
export const input = ref('');
export const ticketExistant = ref({ siren: '', id_immeuble: '' })
export const dateCreation = ref('')
export const dateMaintenance = ref('')
export const dateCloture = ref('')
export const dateValidation = ref('')
export const inseeTicket = ref('')


export const myArray = ref([
    { _id: 't', firstname: '', lastname: '', company: '' },
    { _id: 'a', firstname: '', lastname: '', company: '' }
])

export const myArray2 = ref([
    { _id: 't', firstname: '', lastname: '', company: '' }
])

export const loadTicket = async (siren: any, immeuble: any, idTicket: string) => {
    //console.log('idTicket', idTicket)
    const ticketServeur = await getTicketService(siren, immeuble, idTicket);
    //console.log('ticketExistant', ticketExistant)
    if (ticketServeur.length > 0 && !ticketServeur.includes('DOCTYPE')) {
        ticketExistant.value = JSON.parse(ticketServeur);
        const parsed = JSON.parse(ticketServeur)
        //console.log('tickpard ', parsed)
        ticketExistantId.value = parsed.idTicket;
        intervention.value = parsed.intervention
        idImmeuble.value = parsed.id_immeuble
        pboconcerne.value = parsed.r3_pbo_concerne
        signalContinuite.value = parsed.signal
        rapportcourt_r3.value = parsed.rapport_r3
        rapportcourt_maintenance.value = parsed.rapport_r3_maintenance
        rapportcourt_t7.value = parsed.rapport_t7
        rapportcourt_t7_maintenance.value = parsed.rapport_t7_maintenance
        pboconcerne_t7.value = parsed.t7_pbo_concerne
        intervention_t7.value = parsed.intervention_t7
        motifT7.value = parsed.signal_t7
        intervenants.value = parsed.intervenants;
        dateCreation.value = parsed.date_creation;
        dateMaintenance.value = parsed.date_maintenance;
        dateCloture.value = parsed.date_cloture;
        dateValidation.value = parsed.date_validation;
        inseeTicket.value = parsed.insee
        listDesIntervenants()
    } else {
        //console.log('ticketExistant', 'aucun ticket')
        ticketExistantId.value = 'Aucun'
    }
}

export async function listDesUsers() {
    const mesUsers = await filteredListUsers();
  
    if (input.value.length === 0) {
      myArray.value = [{ _id: 't', firstname: '', lastname: '', company: '' }];
    } else {
      const searchValue = input.value.toLowerCase();
      const keywords = searchValue.split(' ');
  
      myArray.value = mesUsers.filter((point_technique: any) => {
        const firstNameLower = point_technique.firstname.toLowerCase();
        const lastNameLower = point_technique.lastname.toLowerCase();
        const fullNameLower = `${firstNameLower} ${lastNameLower}`;
  
        return keywords.every(kw => fullNameLower.includes(kw));
      }).slice(0, 5);
    }
  }
  

export async function listDesIntervenants() {
    //console.log(ticketExistantId.value);
    //console.log(myArray2.value[0]);
    const mesUsers = await filteredListIntervenants(ticketExistantId.value);
    myArray2.value = JSON.parse(mesUsers);
}

export const sendTicketService = async (ticket: any, ticketToUpdate: string, siren: string, id_immeuble: string) => {
    let response: any;

    switch (ticketToUpdate) {
        case "Aucun":
            //console.log("create")
            response = await fetch(`${prodEnvironment.baseUrl}api/v2/ticket`, {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(ticket)
            })
                .then(async res => {
                    const data = await res.json()
                    if (await res.status === 500) showConfirm("", "Veuillez telecharger une photo avant d'envoyer un ticket", false)
                    else if (await res.status === 200) showConfirm("", "Envoi du ticket réussi", false)
                    else if (await res.status === 403) showConfirm("", data.message, false)


                })
            break;
        default:
            //console.log("update")
            //console.log(ticket)
            patchTicketService(ticket, siren, id_immeuble)
            break;
    }

}

export const sendTicketServiceM = async (ticket: any, ticketToUpdate: string, siren: string, id_immeuble: string) => {
    let response: any;
    //console.log('ticket qui va SUBIR ', ticket)
    switch (ticketToUpdate) {
        case "Aucun":
            //console.log("create")
            response = await fetch(`${prodEnvironment.baseUrl}api/v2/ticket/`, {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(ticket)
            })
                .then(async res => {
                    if (await res.status === 500) showConfirm("", "Veuillez telecharger une photo avant d'envoyer un ticket", false)
                    else if (await res.status === 200) showConfirm("", "Envoi du ticket réussi", false)
                })
            break;
        default:
            //console.log("update")
            patchTicketServiceM(ticket, siren, id_immeuble)
            break;
    }

}


export const loadTicketsIMB = async (siren: string, id_immeuble: string) => {
    //PENSER A MODIFIER LE BACK EN CONSEQUENCE
    const response = await fetch(`${prodEnvironment.baseUrl}api/v2/tickets/${siren}/${id_immeuble.replaceAll('/', '-')}`, {
        method: "GET",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then(async res => {
            const resText = await res.text();
            //console.log(resText)
            relatedTickets.value = []
            JSON.parse(resText).filter((point_technique: any) => {
                relatedTickets.value.push(point_technique)
            }
            )
        }).catch((err) => {
            //console.log(err)
        });
}


export const getTicketService = async (siren: string, id_immeuble: string, idTicket: string) => {
    const response = await fetch(`${prodEnvironment.baseUrl}api/v2/ticket/${idTicket}/${siren}`, {
        method: "GET",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then(async res => await res.text())
    return response
}

export const patchTicketService = async (ticket: any, siren: string, id_immeuble: string) => {
    //console.log('ticket', ticket)
    const response = await fetch(`${prodEnvironment.baseUrl}api/v2/ticket/${ticket.idTicket}/${siren}/${id_immeuble.replaceAll('/', '-')}`, {
        method: "PATCH",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(ticket)
    })
        .then(async res => {
            const data = await res.json()
            if (await res.status === 200) presentToast("Ticket mis à jour", 'info')
            else presentToast(data.message, 'danger')

        });

}


export const patchTicketServiceM = async (ticket: any, siren: string, id_immeuble: string) => {
    const response = await fetch(`${prodEnvironment.baseUrl}api/v2/ticketmanage/${ticket.idTicket}/${siren}/${id_immeuble.replaceAll('/', '-')}`, {
        method: "PATCH",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(ticket)
    })
        .then(async res => {
            if (await res.status === 200) {
                presentToast("Ticket mis à jour", 'info');
                filtreTicket.value = ticket.etape;
                //console.log("ticket miseajouré", ticket)

            }

            else presentToast("Erreur lors de la mise à jour du ticket", 'danger')
        });


}

export const suppressionTicket = async (idTicket: any) => {
    const response = await fetch(`${prodEnvironment.baseUrl}api/v2/ticket/${idTicket}`, {
        method: "DELETE",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        }
    })

    const data = await response.json();
    if (await response.status === 200) presentToast("Ticket supprimé", 'info')
    else presentToast(data.message, 'danger')
}

export const exportTicketsService = async () => {
    const response = await fetch(`${prodEnvironment.baseUrl}api/v2/exporttickets`, {
        method: "GET",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        },
    })

    const data = response;
    return await data;
}

export interface Ticket {
    "signal": string,
    "tube": string,
    "fibre": string,
    "id_immeuble": string,
    "adresse_immeuble": string,
    "rapport_r3"?: string,
    "rapport_r3_maintenance"?: string,
    "rapport_t7"?: string,
    "rapport_t7_maintenance"?: string,
    "intervention"?: string,
    "r3_pbo_concerne"?: string,
    "t7_pbo_concerne"?: string,
    "tag": string,
    "insee": string,
    "commune": string,
    "etape": string,
    isPrivate?: boolean,
}